export default __webpack_public_path__ + "static/media/mergeLogo.4acba5c7.png";